module.exports = __webpack_public_path__ + "static/EZ_logo-c6fcf1db53741151c265a6316dd13e0f.png";